import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  ButtonM,
  ButtonS,
  ButtonXS,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import amoChangeImg from "../../styles/images/img_amo_change.png";
import amoImg from "../../styles/images/img_amo.png";
import changeBtn from "../../styles/images/img_change_btn.png";
import historyBtn from "../../styles/images/img_history_btn.png";
import addBtn from "../../styles/images/img_add_btn.png";
import { ReactComponent as IcoCopy } from "../../styles/images/ico_copy.svg";
import TopPointBanner from "../main/TopPointBanner";
import { returnLoginStatus } from "../hooks/authFunc";
import { useSelector } from "react-redux";
import CopyToClipboard from "react-copy-to-clipboard";
import { maskAddress } from "../hooks/basicFunc";

const HaveWallet = () => {
  const navigate = useNavigate();
  const isLogin = returnLoginStatus();
  const userInfo = useSelector((state) => state.user.userInfo);
  const wallet = userInfo.amoWallet;
  return (
    <Section className="nonePaddingTop">
      <div>
        {isLogin && <TopPointBanner />}
        <Content>
          <div>
            <ImgWrap margintop="6.5" imgwidth="11.7">
              <img src={amoChangeImg} alt="" />
            </ImgWrap>
            <ImgWrap margintop="3" imgwidth="11.1">
              <img src={amoImg} alt="" />
            </ImgWrap>
            <CoinAddressWrap>
              <TextDiv>
                <p>
                  부리또 <span>AMO(KLAY)</span> 코인 주소
                </p>
              </TextDiv>
              <CoinAddress>
                <p>
                  {maskAddress(wallet)}
                  <CopyToClipboard
                    className="pointer"
                    text={wallet}
                    onCopy={() =>
                      console.log("클립보드에 복사되었습니다.", wallet)
                    }
                  >
                    <IcoCopy />
                  </CopyToClipboard>
                  {/* <IcoCopy
                    onClick={() => {
                      console.log("copy");
                    }}
                  /> */}
                </p>
              </CoinAddress>
            </CoinAddressWrap>
          </div>
        </Content>
      </div>

      <HaveWalletBtns>
        <div>
          <img src={changeBtn} alt="" />
          <ButtonXS
            onClick={() => {
              navigate("/amo/change/init");
            }}
          >
            교환
          </ButtonXS>
        </div>
        <div>
          <img src={historyBtn} alt="" />
          <ButtonXS
            onClick={() => {
              navigate("/amo/history");
            }}
          >
            거래내역
          </ButtonXS>
        </div>
        <div>
          <img src={addBtn} alt="" />
          <ButtonXS
            onClick={() => {
              navigate("/amo/wallet/new");
            }}
          >
            새주소 등록
          </ButtonXS>
        </div>
      </HaveWalletBtns>
    </Section>
  );
};

export default HaveWallet;
const HaveWalletBtns = styled(Btns)`
  display: flex;
  justify-content: space-between;
  div {
    width: calc(33.33% - 0.7rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      width: 6rem;
      margin: 0 auto;
    }
    button {
      width: 100%;
      margin-top: 2rem;
      height: 4rem;
      border-radius: 2rem;
      background-color: ${({ theme }) => theme.color.purple_dark};
    }
  }
`;
const CoinAddressWrap = styled.div`
  margin-top: 3rem;
  text-align: center;
  p {
    line-height: 1.4rem; /* 100% */
  }
`;
const CoinAddress = styled.div`
  margin-top: 1rem;
  height: 4.6rem;
  background-color: ${({ theme }) => theme.color.purple_bg_light};
  border-radius: 2.3rem;

  display: flex;
  align-items: center;
  justify-content: center;
  p {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    line-height: 2rem; /* 166.667% */
    font-family: NanumSquareB;
    position: relative;

    svg {
      width: 1.2rem;
      height: 1.2rem;

      position: absolute;
      margin: auto;
      right: -3rem;
      top: 0;
      bottom: 0;
    }
  }
`;
